module.exports = __webpack_public_path__ + "static/img/publicity-icon6.c9c0a1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon6.png
// module id = ivwd
// module chunks = 1